import css from './GrandTotalStep2Buttons.module.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { useState } from 'react';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { ROUTES } from '@configs/AppRoutes';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { useFragmentsStore } from '../../../../../Stores/FragmentsStore';
import { HasFragmentItems } from '@viewModels/FragmentsViewModel/Services/HasFragmentItems';

export const GrandTotalStep2Buttons: React.FC = () => {
    const fragmentsViewModel = new FragmentsViewModel();
    const { parsedFragments, isFragmentsUpdateLoading } = useFragmentsStore();

    const { bearerToken } = useAuthorizationViewModel();

    const { projectId, viewMode } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { fromTemplate } = location.state || {};

    const [isDesktop] = useMediaType();
    const pdfLink = `${import.meta.env.VITE_BASE_URL_LINK}/generate-pdf/project/${projectId}?token=${bearerToken}`;

    const [isSelectingProductsToOrder, setIsSelectingProductsToOrder] =
        useState(false);
    const [isSavingProject, setIsSavingProject] = useState(false);

    const handleNextStep = async () => {
        if (viewMode === StepsViewModeEnum.PRESENTATION) {
            navigate(ROUTES.STEP3.getPath(StepsViewModeEnum.PRESENTATION), {
                state: { fromTemplate },
            });
        }
        setIsSelectingProductsToOrder(true);

        const response =
            await fragmentsViewModel.updateProjectParsedFragments();

        if (!response) {
            notifyErrorCustom('Failed update project');
            setIsSelectingProductsToOrder(false);
            return;
        }

        notifySuccessCustom('Project updated successfully');
        setIsSelectingProductsToOrder(false);
        navigate(
            ROUTES.STEP3.getPath(StepsViewModeEnum.PROJECT, `${projectId}`)
        );
    };

    const handleSave = async () => {
        setIsSavingProject(true);

        const response =
            await await fragmentsViewModel.updateProjectParsedFragments();
        setIsSavingProject(false);

        if (!response) {
            notifyErrorCustom('Failed update project');
            return;
        }

        notifySuccessCustom('Project updated successfully');
        navigate(ROUTES.BOM);
    };

    return (
        <>
            {isDesktop ? (
                <div className={css.btns}>
                    <BasicButton
                        id={
                            CustomProjectStep2ElementsIdsEnum.TOTAL_PRICE_PAGE_STEP2_BLOCK_PDF_BUTTON
                        }
                        extraClassName={css.btn}
                        isReversed={true}
                        disabled={viewMode === StepsViewModeEnum.PRESENTATION}
                    >
                        {viewMode === StepsViewModeEnum.PRESENTATION ? (
                            <div className={css.pdfLink}>Download PDF</div>
                        ) : (
                            <a href={pdfLink} className={css.pdfLink}>
                                Download PDF
                            </a>
                        )}
                    </BasicButton>

                    <BasicButton
                        id={
                            CustomProjectStep2ElementsIdsEnum.TOTAL_PRICE_PAGE_STEP2_BLOCK_SELECT_PRODUCT_BUTTON
                        }
                        onClick={handleNextStep}
                        isLoading={isSelectingProductsToOrder}
                        extraClassName={css.btn}
                        disabled={!HasFragmentItems(parsedFragments)}
                    >
                        Select products to order
                    </BasicButton>

                    <BasicButton
                        onClick={handleSave}
                        extraClassName={css.btn}
                        isReversed={true}
                        disabled={
                            isFragmentsUpdateLoading ||
                            viewMode === StepsViewModeEnum.PRESENTATION
                        }
                        id={
                            CustomProjectStep2ElementsIdsEnum.TOTAL_PRICE_PAGE_STEP2_BLOCK_SAVE_PROJECT_BUTTON
                        }
                        isLoading={isSavingProject}
                    >
                        Save project
                    </BasicButton>
                </div>
            ) : (
                <div className={css.btns}>
                    <BasicButton
                        onClick={handleNextStep}
                        extraClassName={css.btn}
                        isLoading={isSelectingProductsToOrder}
                        disabled={!HasFragmentItems(parsedFragments)}
                    >
                        Select products to order
                    </BasicButton>

                    <div className={css.saveAndDownloadBtns}>
                        <BasicButton
                            onClick={handleSave}
                            extraClassName={css.btn}
                            isReversed={true}
                            disabled={
                                isFragmentsUpdateLoading ||
                                viewMode === StepsViewModeEnum.PRESENTATION
                            }
                            isLoading={isSavingProject}
                        >
                            Save project
                        </BasicButton>

                        <BasicButton
                            extraClassName={css.btn}
                            isReversed={true}
                            disabled={
                                viewMode === StepsViewModeEnum.PRESENTATION
                            }
                        >
                            <a href={pdfLink} className={css.pdfLink}>
                                Download PDF
                            </a>
                        </BasicButton>
                    </div>
                </div>
            )}
        </>
    );
};
